import React from 'react'

export default function (props) {
  return <div className="absolute rounded-lg mb-4 z-50 bottom-0 right-0 mr-36 transition-all duration-700">
    <div className="flex flex-row items-end gap-3">
      {props.children}
    </div>
  </div>
}
